import { render, staticRenderFns } from "./rankingList2.vue?vue&type=template&id=30aa032c&scoped=true&"
import script from "./rankingList2.vue?vue&type=script&lang=js&"
export * from "./rankingList2.vue?vue&type=script&lang=js&"
import style0 from "./rankingList2.vue?vue&type=style&index=0&id=30aa032c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa032c",
  null
  
)

export default component.exports